__turbopack_context__.v({
  "badgeRow": "Hero-module__RGHkYG__badgeRow",
  "brandRow": "Hero-module__RGHkYG__brandRow",
  "clueLogoType": "Hero-module__RGHkYG__clueLogoType",
  "content": "Hero-module__RGHkYG__content",
  "ctaRow": "Hero-module__RGHkYG__ctaRow",
  "divider": "Hero-module__RGHkYG__divider",
  "heroBuyNowButton": "Hero-module__RGHkYG__heroBuyNowButton",
  "heroSection": "Hero-module__RGHkYG__heroSection",
  "hsaBadgeDesktop": "Hero-module__RGHkYG__hsaBadgeDesktop",
  "hsaBadgeMobile": "Hero-module__RGHkYG__hsaBadgeMobile",
  "leftContent": "Hero-module__RGHkYG__leftContent",
  "offersBottomBar": "Hero-module__RGHkYG__offersBottomBar",
  "offersDesktop": "Hero-module__RGHkYG__offersDesktop",
  "offersMobile": "Hero-module__RGHkYG__offersMobile",
  "title": "Hero-module__RGHkYG__title",
  "uhLogoType": "Hero-module__RGHkYG__uhLogoType",
});
